import { render, staticRenderFns } from "./SharedMapIconSaintJeanBaptiste.vue?vue&type=template&id=5511a69a&scoped=true&"
var script = {}
import style0 from "./SharedMapIconSaintJeanBaptiste.vue?vue&type=style&index=0&id=5511a69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5511a69a",
  null
  
)

export default component.exports